module.exports = __webpack_public_path__ + "img/dataRisk.49b091a6.png";